import { trpc } from '@/shared/api';

/** 내 계정(users.me) 캐시 무효화 — 회원정보 변경 뒤 다시 읽는다. 재조회 promise 를 돌려준다. */
export const useInvalidateMe = (): (() => Promise<void>) => {
  const utils = trpc.useUtils();

  return () => utils.users.me.invalidate();
};
